import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const ItineraryHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Itinerarios"
    text="Éste es el módulo de Gestión de Itinerarios."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ ItineraryUnit }) => ({
  cards: ItineraryUnit.UnitHome.get('cards'),
  breadcrumbs: ItineraryUnit.UnitHome.get('breadcrumbs'),
});

ItineraryHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(ItineraryHome);
